import React, { JSX, SetStateAction } from 'react'
import classes from './ShareModalContent.module.sass'
import {
  TelegramIcon,
  TelegramShareButton,
  VKIcon,
  VKShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  OKIcon,
  OKShareButton,
  EmailIcon,
  EmailShareButton,
} from 'react-share'
import { IoArrowBack } from 'react-icons/io5'
import { FiCopy } from 'react-icons/fi'
import { SharePayload } from '../../../../types/interfaces'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../../../../store/slices/currentUserSlice'
import { useCopyToClipboard } from '../../../../hooks/useCopyToClipboard'

type Props = {
  text: string
  url: string
  setModalActive: React.Dispatch<SetStateAction<boolean>>
  shareBufferContent?: JSX.Element | JSX.Element[] | string
  chatShareAction: (payload: SharePayload) => void
}

const ShareModalContent = ({ text, url, setModalActive, chatShareAction }: Props) => {
  const currentUser = useSelector(selectCurrentUser)
  const { copy, copied } = useCopyToClipboard()

  const handleCopyLink = async () => {
    await copy(url)
  }

  const handleChatShare = () => {
    chatShareAction({ text, url })
    setModalActive(false)
  }

  return (
    <div className={classes.Container}>
      <div className={classes.header}>
        <button className={classes.backButton} onClick={() => setModalActive(false)}>
          <IoArrowBack size={24} />
        </button>
        <h2 className={classes.title}>Поделиться</h2>
        <div className={classes.placeholder} />
      </div>

      <div className={classes.content}>
        <div className={classes.IconsRow}>
          {currentUser && (
            <div className={classes.ShareToChat} onClick={handleChatShare}>
              <div className={classes.Logo}>logid</div>
            </div>
          )}

          <div onClick={() => setModalActive(false)}>
            <WhatsappShareButton url={url} title={text}>
              <WhatsappIcon size={42} style={{ borderRadius: '50%' }} />
            </WhatsappShareButton>
          </div>

          <div onClick={() => setModalActive(false)}>
            <TelegramShareButton url={url} title={text}>
              <TelegramIcon size={42} style={{ borderRadius: '50%' }} />
            </TelegramShareButton>
          </div>

          <div onClick={() => setModalActive(false)}>
            <VKShareButton url={url} title={text}>
              <VKIcon size={42} style={{ borderRadius: '50%' }} />
            </VKShareButton>
          </div>

          <div onClick={() => setModalActive(false)}>
            <OKShareButton url={url} title={text}>
              <OKIcon size={42} style={{ borderRadius: '50%' }} />
            </OKShareButton>
          </div>

          <div onClick={() => setModalActive(false)}>
            <EmailShareButton url={url} subject={text} body={`${text}\n\n${url}`}>
              <EmailIcon size={42} style={{ borderRadius: '50%' }} />
            </EmailShareButton>
          </div>

          <button
            className={`${classes.copyButton} ${copied ? classes.copied : ''}`}
            onClick={handleCopyLink}
            title="Скопировать ссылку"
          >
            <div className={classes.copyCircle}>
              <FiCopy size={20} />
            </div>
          </button>
        </div>
      </div>
    </div>
  )
}

export default ShareModalContent
